import React, { useCallback, useState } from 'react';
import axios from 'axios';
import {
  Flex,
  IconButton,
  Text,
  Icon,
  icons,
} from '@tapresearch/ui/components';

interface ContextBannerProps {
  organizationName: string;
}
export const OrganizationalContextBanner = ({
  organizationName,
}: ContextBannerProps) => {
  const [isLeaving, setIsLeaving] = useState(false);

  const onExitContext = useCallback(async () => {
    setIsLeaving(true);
    await axios.post('/organizations/current_organization/leave');
    window.location.assign('/organizations/manage');
  }, []);

  return (
    <Flex
      {...{
        align: 'center',
        bg: 'fuschia.50',
        color: 'gray.800',
        fontWeight: 'medium',
        position: 'relative',
        w: '92%',
        m: '0 auto',
        rounded: 'md',
        mt: 4,
        p: 4,
      }}
    >
      <Flex flex={1}>
        <Flex
          flexDir="column"
          w="full"
          mr={8}
          fontWeight="normal"
          color="fuschia.600"
          fontSize="md"
        >
          <Flex align="center">
            <Icon boxSize={6} mr={2} icon={icons.io5.Business} />
            Managing
          </Flex>
          <Flex mt={2} align="center">
            <Text color="gray.800" fontSize="sm" fontWeight="normal">
              {organizationName}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex flex={1} justify="flex-end">
        <IconButton
          aria-label="Exit context"
          size="md"
          colorScheme="fuschia"
          variant="ghost"
          color="fuschia.600"
          isLoading={isLeaving}
          icon={<Icon m={0} boxSize={5} icon={icons.fi.LogOut} />}
          onClick={onExitContext}
        />
      </Flex>
    </Flex>
  );
};
